import React from 'react';
import { Trans } from 'react-i18next';
import { instanceOf } from 'prop-types';
import { List } from 'immutable';

import { Icon } from '@ets-global/b2c-website-ui';

const PreparationChecklist = ({ candidatePreparationChecklist }) => {
  return (
    <div className="account-session-detail__infos">
      <p className="account-session-detail__infos-title">
        <Trans>account.session.detail.preparation-check-list.title</Trans>
      </p>
      <ul>
        {candidatePreparationChecklist.map((item, key) => (
          <li key={key}>
            <Icon name={'tick'} />
            {item.get('text')}
          </li>
        ))}
      </ul>
    </div>
  );
};

PreparationChecklist.propTypes = {
  candidatePreparationChecklist: instanceOf(List).isRequired,
};

export default PreparationChecklist;
